"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFinalForm = require("react-final-form");

var _TextFieldAdapter = _interopRequireDefault(require("../../Adapters/TextFieldAdapter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TaxPractitionerNumberField = function TaxPractitionerNumberField(props) {
  var required = props.required;

  if (required === undefined) {
    required = true;
  }

  var isValid = function isValid(value) {
    var re = /^[0-9]{1,10}$/;
    return (value === undefined || (value === null || value === void 0 ? void 0 : value.length) === 0 || !re.test(value)) && required ? "Please enter a valid Tax Practitioner Number" : undefined;
  };

  return /*#__PURE__*/_react.default.createElement(_reactFinalForm.Field, {
    name: "taxPractitionerNumber",
    validate: isValid,
    label: "Tax Practitioner Number",
    component: _TextFieldAdapter.default,
    subscription: {
      touched: true,
      value: true,
      error: true
    },
    fullWidth: true,
    inputProps: {
      maxLength: 10
    },
    required: true
  });
};

var _default = TaxPractitionerNumberField;
exports.default = _default;